
import { defineComponent, computed } from 'vue'
import { colorValidator } from '@/views/validation'

export default defineComponent({
  props: {
    color: {
      type: String as () => string | null,
      validator: colorValidator
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: {
    click: () => true
  },
  setup (props, { emit }) {
    const appendClass = computed(() => {
      const append = ['btn-' + props.color]
      if (props.loading) {
        append.push('loading-button__now-loading')
      }
      return append
    })
    const onClicked = () => {
      emit('click')
    }

    return {
      appendClass,
      onClicked
    }
  }
})
